<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M9 3c2.07 0 3.75 1.68 3.75 3.75 0 .795-.293 1.74-.75 2.715l1.117 1.117c.66-1.312 1.133-2.655 1.133-3.832A5.246 5.246 0 0 0 9 1.5c-1.38 0-2.625.533-3.563 1.395L6.51 3.967A3.722 3.722 0 0 1 9 3Zm0 1.875a1.84 1.84 0 0 0-1.17.42l2.625 2.625c.262-.322.42-.728.42-1.17 0-1.035-.84-1.875-1.875-1.875Zm-6.442-2.73L1.5 3.203l2.385 2.385A5.416 5.416 0 0 0 3.75 6.75C3.75 10.688 9 16.5 9 16.5s1.252-1.387 2.535-3.262l2.512 2.512 1.058-1.057L2.558 2.145ZM9 14.16c-1.508-1.935-3.6-5.055-3.735-7.192l5.19 5.19A31.916 31.916 0 0 1 9 14.16Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
